import React from 'react'

import {Navigate, useLocation} from 'react-router'

import {Permission} from '../../types'

import ROUTES from '../../routes'

type Props = {
  isAuthenticated: boolean
  isPermitted: boolean
  providerExists: boolean
  isAdminMode?: boolean
  children: React.ReactNode
}
export const RequireAuth = ({
  isAuthenticated,
  isPermitted,
  providerExists,
  isAdminMode = false,
  children,
}: Props) => {
  const location = useLocation()

  if (isAuthenticated && isPermitted && !providerExists && isAdminMode) {
    return <Navigate to={ROUTES.SIGN_IN_ADMIN} state={{from: location.pathname}} />
  }

  if (isAuthenticated && isPermitted && providerExists) {
    return <>{children}</>
  }

  if (isAuthenticated && !isPermitted && providerExists) {
    return <Navigate to={ROUTES.FORBIDDEN} />
  }

  return <Navigate to={ROUTES.SIGN_IN} state={{from: location.pathname}} />
}

export const isPermitted = (
  permission: Permission,
  requiredPermissions: Permission[] | undefined
) =>
  !requiredPermissions ||
  requiredPermissions.length === 0 ||
  requiredPermissions.includes(permission)
